<template>
  <div class="app-container svg-editor-container">
    <div class="svg-editor-body-container">
      <div class="icon-panel-container">
        <div class="editor-header">
          <el-button-group>
            <el-tooltip class="item" effect="dark" content="添加分组" placement="bottom">
              <el-button size="mini" icon="el-icon-plus" @click="addGroupShow = true;GroupName = ''" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除分组" placement="bottom">
              <el-button size="mini" icon="el-icon-delete" @click="DelSVGGroupData()" />
            </el-tooltip>
          </el-button-group>
          <div class="d-flex" style="margin-top:10px;margin-bottom:10px">
            <span style="font-size: 16px">分组：</span>
            <el-select v-model="selectGroup" style="width:60%" size="mini" placeholder="请选择分组" @change="loadData">
              <el-option
                v-for="item in groupList"
                :key="item.GroupId"
                :label="item.GroupName"
                :value="item.GroupId" />
            </el-select>
          </div>
          <el-button-group>
            <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
              <el-button size="mini" icon="el-icon-document-checked" @click="handleSave" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导出SVG" placement="bottom">
              <el-button size="mini" icon="el-icon-guide" @click="exportSvg" />
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导出JSON" placement="bottom">
              <el-button size="mini" icon="el-icon-link" @click="exportJSON" />
            </el-tooltip>
          </el-button-group>
        </div>
        <LeftSvgIconPanel @svgInfoData="loadSvgInfoData" />
      </div>
      <div class="svg-editor-main-container">
        <div
          ref="canvas"
          class="canvansDiv"
          :style="'transform: scale('+scaleValue+');transform-origin: 0 0 0;'"
          @mousemove="handleMouseMove"
          @mousedown="handleMousedownCanvas"
          @mouseup="handleMouseupCanvas"
          @dblclick="handleDblClick"
          @mousewheel="handleMouseWheel">
          <!--拖动辅助线-->
          <div id="guide-x" ref="guidex_dom" :style="'border-top: '+1/scaleValue+'px dashed #55f'" />
          <div id="guide-y" ref="guidey_dom" :style="'border-left: '+1/scaleValue+'px dashed #55f'" />
          <!-- 画布 -->
          <svg
            id="svgCanvas"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="background-color:#bdbdd6de"
            :width="width+'px'"
            :height="height+'px'">
            <defs />
            <filter id="solid" x="0" y="0" width="1" height="1">
              <feFlood flood-color="rgb(255,255,255)" />
              <feComposite in="SourceGraphic" />
            </filter>
            <g
              v-for="(item,index) in svgLists"
              :id="item.id"
              :key="item.id"
              style="cursor:pointer"
              :class="selectSvgInfo.id==item.id?'topo-layer-view-selected':''"
              :title="item.title"
              :transform="'translate('+(item.svgPositionX)+','+(item.svgPositionY)+')' +'rotate('+item.angle+')' +'scale('+item.size+')'"
              @mousedown="handleMousedownSvg(item.id,index,item.svgPositionX,item.svgPositionY,$event)">
              <SvgComponents :component_prop="item" :svgInfoData="svgInfoData" />
            </g>
          </svg>
        </div>
        <div style="position: absolute;top: 5px;color: #fff;left: 10%;">
          {{ wiringDiagram.name }} {{ wiringDiagram.version }} (画布大小:{{ width }}px * {{ height }}px)
        </div>
        <div class="block zoom-container">
          <el-slider v-model="scaleValue" :min="0.1" :max="2" :step="0.1" height="5px" style="width:200px" @change="scaleValueChange" />
        </div>
      </div>
      <div class="attribute-panel-container">
        <right-attribute-panel :svg-info="selectSvgInfo" :devices="devices" @setTableAttr="setTableAttr" />
      </div>
    </div>
    <el-dialog
      title="添加分组"
      :visible.sync="addGroupShow"
      width="30%">
      <div class="d-flex">
        <span>分组名称：</span>
        <el-input
          v-model="GroupName"
          style="width: 80%;"
          size="mini"
          placeholder="请输入分组名称" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addGroupShow = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="addGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import LeftSvgIconPanel from '@/components/svg-edit/components/LeftSvgIconPanel.vue'
import RightAttributePanel from '@/components/svg-edit/components/RightAttributePanel.vue'
import SvgComponents from '@/components/svg-edit/components/SvgComponents.vue'
import { saveSVGData, getSVGDataByIdStr, GetSVGGroupData, DelSVGGroupData, GetProjectTreeYiCiTu } from '@/api/svg-edit/svgEdit'
import { convertDataToFormData } from '@/utils/utils'

export default {
  components: { LeftSvgIconPanel, SvgComponents, RightAttributePanel },
  props: {
    svgId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      width: 1920,
      height: 1080,
      svgInfoData: [], // 接口获取到的组件数据
      svgLists: [], // svg列表
      // 鼠标位置
      mousePosition: {
        positionX: '',
        positiony: ''
      },
      selectSvg: {
        ID: '', // 要移动的svg
        Index: 0,
        mPositionX: 0, // 选中svg时鼠标的x轴坐标
        mPositionY: 0, // 选中svg时鼠标的y轴坐标
        pointX: 0, // 选中svg时svg的x轴坐标
        pointY: 0 // 选中svg时svg的y轴坐标
      },
      mouseStatus: 0, // 鼠标状态 1按下； 0弹起
      selectSvgInfo: {},
      clickType: '', // 鼠标点击行为
      scaleValue: 1, // 缩放倍数
      wiringDiagram: {},
      devices: [],
      groupList: [],
      selectGroup: '',
      addGroupShow: false,
      GroupName: ''
    }
  },
  watch: {
    svgId: function(val) {
      if (val) {
        this.GetSVGGroupData()
      }
    }
  },

  created() {
    const _this = this
    // 当前页面监视键盘输入
    document.onkeydown = function(e) {
      const selectSvgInfo = _this.selectSvgInfo
      if (selectSvgInfo === undefined || selectSvgInfo == null || selectSvgInfo === '') {
        return
      }
      // 事件对象兼容

      // eslint-disable-next-line no-caller
      const e1 = e || window.event || arguments.callee.caller.arguments[0]
      // 键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
      if (e1 && e1.keyCode === 37) {
        e.preventDefault()
        selectSvgInfo.svgPositionX -= 1
      } else if (e1 && e1.keyCode === 38) {
        e.preventDefault()
        selectSvgInfo.svgPositionY -= 1
      } else if (e1 && e1.keyCode === 39) {
        e.preventDefault()
        selectSvgInfo.svgPositionX += 1
      } else if (e1 && e1.keyCode === 40) {
        e.preventDefault()
        selectSvgInfo.svgPositionY += 1
      } else if (e1 && e1.keyCode === 46) {
        e.preventDefault()
        // 根据当前id找到当前元素的index
        const selectSvgIndex = _this.svgLists.indexOf(_this.svgLists.filter(f => f.id === selectSvgInfo.id)[0])
        _this.svgLists.splice(selectSvgIndex, 1)
      }
    }
  },
  mounted() {
    const _this = this
    this.$nextTick(() => {
      const canvasdiv = _this.$refs.canvas
      canvasdiv.addEventListener('dragover', function(e) {
        e.preventDefault()
      }, false)
      canvasdiv.addEventListener('drop', function(e) {
        e.preventDefault()
        if (_this.$store.state.svgEditor.currentlySelectedToolBar.Type === '' || _this.$store.state.svgEditor.currentlySelectedToolBar.CreateType !== 'draggable') {
          return
        }
        const eChartsOption = _this.$store.state.svgEditor.currentlySelectedToolBar.EChartsOption
        // 根据类型和鼠标位置创建组件
        const svgItem = {
          id: _this.uuid(),
          title: _this.$store.state.svgEditor.currentlySelectedToolBar.Title,
          type: _this.$store.state.svgEditor.currentlySelectedToolBar.Type,
          typeName: _this.$store.state.svgEditor.currentlySelectedToolBar.TypeName,
          svgColor: _this.$store.state.svgEditor.currentlySelectedToolBar.Color,
          Ia: _this.$store.state.svgEditor.currentlySelectedToolBar.Ia,
          Ib: _this.$store.state.svgEditor.currentlySelectedToolBar.Ib,
          Ic: _this.$store.state.svgEditor.currentlySelectedToolBar.Ic,
          zxyg: _this.$store.state.svgEditor.currentlySelectedToolBar.zxyg,
          svgPositionX: e.offsetX,
          svgPositionY: e.offsetY,
          echartsOption: eChartsOption ? JSON.parse(eChartsOption) : '',
          size: 1,
          angle: 0
          // translate:`translate(${this.mousePosition.positionX},${this.mousePosition.positionY})`
        }
        _this.svgLists.push(svgItem)
        _this.selectSvgInfo = svgItem
      }, false)
    })
  },
  methods: {
    GetSVGGroupData() {
      GetSVGGroupData({ IdStr: this.svgId }).then(e => {
        this.groupList = e
        if (e.length) {
          this.selectGroup = e[0].GroupId
          this.loadData()
        } else {
          this.svgLists = []
        }
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    // 根据线路图获取设备
    fetchDevices() {
      const { projectList } = this.$store.getters
      for (let i = 0; i < projectList.length; i++) {
        const pds = projectList[i].Children.find(e => {
          return e.IdStr === this.svgId
        })
        if (pds) {
          this.devices = pds.Children
          break
        }
      }
    },
    GetProjectTreeYiCiTu() {
      GetProjectTreeYiCiTu({ ProjectIdStr: this.$store.getters.selectProject }).then(res => {
        console.log(res)
        const pds = res[0].Children.find(e => {
          return e.IdStr === this.svgId
        })
        if (pds) {
          this.devices = pds.Children
        }
      })
    },
    loadSvgInfoData(val) {
      this.svgInfoData = val
    },
    handleSave() {
      const params = {
        IdStr: this.svgId,
        GroupId: this.selectGroup,
        Content: JSON.stringify(this.svgLists),
        Width: this.width,
        Height: this.height
      }
      this.$confirm('此操作将保存当前绘制, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        saveSVGData(convertDataToFormData(params)).then((res) => {
          this.$message.success('保存成功!')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        })
      })
    },
    exportJSON() {
      localStorage.setItem('svginfo', JSON.stringify(this.svgLists))
      const datastr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.svgLists))
      const download = document.createElement('a')
      download.setAttribute('href', datastr)
      download.setAttribute('download', `${this.wiringDiagram.name}(${this.wiringDiagram.version}).json`)
      download.click()
      download.remove()
      console.log(JSON.stringify(this.svgLists))
    },
    exportSvg() {
      let exportStr = document.querySelector('#svgCanvas').outerHTML
      exportStr = exportStr.replace('width="100%"', 'width="1920"').replace('height="100%"', 'height="1080"')
      const datastr = 'data:text;charset=utf-8,' + encodeURIComponent(exportStr)
      const download = document.createElement('a')
      download.setAttribute('href', datastr)
      download.setAttribute('download', `${this.wiringDiagram.name}(${this.wiringDiagram.version}).svg`)
      download.click()
      download.remove()
      console.log(exportStr)
    },
    // 载入数据
    async loadData() {
      // 根据svgid（配电室id）获取设备列表
      // this.fetchDevices()
      this.GetProjectTreeYiCiTu()
      getSVGDataByIdStr({ IdStr: this.svgId, GroupId: this.selectGroup }).then((res) => {
        if (res.length && res[0].Content) {
          this.svgLists = JSON.parse(res[0].Content)
          this.width = res[0].Width
          this.height = res[0].Height
        } else {
          this.svgLists = []
          this.width = 1920
          this.height = 1080
        }
      })
    },
    // 添加分组
    addGroup() {
      const params = {
        IdStr: this.svgId,
        GroupId: '',
        GroupName: this.GroupName,
        Content: '',
        Width: this.width,
        Height: this.height
      }
      saveSVGData(convertDataToFormData(params)).then((res) => {
        this.$message.success('分组保存成功!')
        this.addGroupShow = false
        this.GetSVGGroupData()
      }).catch(err => {
        this.$message.warning(err)
      })
    },
    DelSVGGroupData() {
      this.$confirm('此操作将永久删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          IdStr: this.svgId,
          GroupId: this.selectGroup
        }
        DelSVGGroupData(param).then(res => {
          this.GetSVGGroupData()
          this.$message.success('删除成功！')
        }).catch(() => {
          this.$message.warning('删除失败！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 预览
    handlePreview() {
      localStorage.setItem('svginfo', JSON.stringify(this.svgLists))
      window.open(this.$router.resolve({ path: '/svg/preview' }).href, '_blank')
    },
    // 放大缩小
    scaleValueChange(newValue) {
      this.scaleValue = newValue
    },
    // 鼠标移动
    handleMouseMove(e) {
      const _this = this
      if (this.clickType === 'draggable') {
        if (this.mouseStatus === 0) {
          return
        }
        const { clientX, clientY } = e
        const svgID = this.selectSvg.ID
        // 排除当前元素剩下的所有svg元素的列表
        const anyPositionList = this.svgLists.filter(function(list) {
          return list.id !== svgID
        })
        // 将要移动的元素坐标设备为鼠标坐标
        let svgPositionX = this.selectSvg.pointX
        let svgPositionY = this.selectSvg.pointY
        svgPositionX += (clientX - this.selectSvg.mPositionX) / this.scaleValue
        svgPositionY += (clientY - this.selectSvg.mPositionY) / this.scaleValue
        setTimeout(function() {
          // 少于十个像素自动吸附
          // 从所有的x坐标列表中查与当前坐标少于10个像素的组件是否存在
          const exitsAdsorbX = anyPositionList.filter(function(list) {
            return (list.svgPositionX - svgPositionX) > -10 && (list.svgPositionX - svgPositionX) < 10
          })
          if (exitsAdsorbX.length > 0) {
            svgPositionX = exitsAdsorbX[0].svgPositionX
          }
          // y轴相同 横向坐标自动吸附
          const exitsAdsorbY = anyPositionList.filter(function(list) {
            return (list.svgPositionY - svgPositionY) > -10 && (list.svgPositionY - svgPositionY) < 10
          })
          if (exitsAdsorbY.length > 0) {
            svgPositionY = exitsAdsorbY[0].svgPositionY
          }
          _this.svgLists[_this.selectSvg.Index].svgPositionX = svgPositionX
          _this.svgLists[_this.selectSvg.Index].svgPositionY = svgPositionY
          // 从所有的x坐标列表中查当前坐标是否存在
          const exitsNowX = anyPositionList.filter(function(list) {
            return list.svgPositionX === svgPositionX
          })
          if (exitsNowX.length > 0) {
            _this.$refs.guidey_dom.style.setProperty('left', svgPositionX - 1 / _this.scaleValue + 'px')
            _this.$refs.guidey_dom.style.display = 'inline'
          } else {
            _this.$refs.guidey_dom.style.display = 'none'
          }
          // 从所有的y坐标列表中查当前坐标是否存在
          const exitsNowY = anyPositionList.filter(function(list) {
            return list.svgPositionY === svgPositionY
          })
          if (exitsNowY.length > 0) {
            _this.$refs.guidex_dom.style.setProperty('top', svgPositionY - 1 / _this.scaleValue + 'px')
            _this.$refs.guidex_dom.style.display = 'inline'
          } else {
            _this.$refs.guidex_dom.style.display = 'none'
          }
        }, 1)
      } else if (this.clickType === 'click') {
        if (this.mouseStatus === 0) {
          return
        }
        this.selectSvgInfo.mPoint.endX = e.offsetX
        this.selectSvgInfo.mPoint.endY = e.offsetY
      }
    },
    /**
     * 鼠标按下
     */
    handleMousedownCanvas(e) {
      if (this.clickType === 'draggable') {
        return
      }
      if (this.$store.state.svgEditor.currentlySelectedToolBar && this.$store.state.svgEditor.currentlySelectedToolBar.CreateType === 'click') {
        // 根据类型和鼠标位置创建组件
        const svg_id = this.uuid()
        const svgItem = {
          id: svg_id,
          title: this.$store.state.svgEditor.currentlySelectedToolBar.Title,
          type: this.$store.state.svgEditor.currentlySelectedToolBar.Type,
          typeName: this.$store.state.svgEditor.currentlySelectedToolBar.TypeName,
          svgColor: this.$store.state.svgEditor.currentlySelectedToolBar.Color,
          svgPositionX: e.offsetX,
          svgPositionY: e.offsetY,
          mPoint: {
            startX: e.offsetX,
            startY: e.offsetY,
            endX: e.offsetX,
            endY: e.offsetY
          },
          size: 1,
          angle: 0
          // translate:`translate(${this.mousePosition.positionX},${this.mousePosition.positionY})`
        }
        this.svgLists.push(svgItem)
        this.selectSvgInfo = svgItem
        this.mouseStatus = 1
        this.clickType = 'click'
      }
    },
    /**
     * 鼠标抬起事件
     */
    handleMouseupCanvas() {
      if (this.mouseStatus === 0) {
        return
      }
      this.$refs.guidex_dom.style.display = 'none'
      this.$refs.guidey_dom.style.display = 'none'

      this.mouseStatus = 0
      if (this.clickType === 'draggable') {
        this.clickType = ''
      }
      if (this.clickType === 'click') {
        if (this.selectSvgInfo.mPoint.startX === this.selectSvgInfo.mPoint.endX && this.selectSvgInfo.mPoint.startY === this.selectSvgInfo.mPoint.endY) {
          // 根据当前id找到当前元素的index
          const selectSvgIndex = this.svgLists.indexOf(this.svgLists.filter(f => f.id === this.selectSvgInfo.id)[0])
          this.svgLists.splice(selectSvgIndex, 1)
          this.selectSvg = {}
          this.selectSvgInfo = {}
        }
      }
    },
    handleDblClick() {

    },
    /**
     * 滚轮事件
     */
    handleMouseWheel(e) {
      // 获取当前选中组件
      const selectSvgInfo = this.selectSvgInfo
      if (selectSvgInfo === undefined || selectSvgInfo == null || selectSvgInfo === '') {
        return
      }
      e.preventDefault()
      // 判断滚轮方向 -100是往上滑 100是下滑
      const svgZoom = e.deltaY < 0 ? 0.1 : -0.1
      selectSvgInfo.size += svgZoom
      selectSvgInfo.size = parseFloat(selectSvgInfo.size.toFixed(1))
      if (selectSvgInfo.size < 1) {
        selectSvgInfo.size = 1
      }
    },
    /**
     * 绘制的SVG图片选择事件
     */
    handleMousedownSvg(id, index, pointX, pointY, e) {
      this.$store.dispatch('clearCurrentlySelectedToolBarAction')
      console.log(1111133)
      // 从数组里面根据index找到当前元素
      this.selectSvg.ID = id
      this.selectSvg.Index = index
      this.mouseStatus = 1
      this.selectSvg.mPositionX = e.clientX
      this.selectSvg.mPositionY = e.clientY
      this.selectSvg.pointX = pointX
      this.selectSvg.pointY = pointY
      this.selectSvgInfo = this.svgLists[index]
      this.clickType = 'draggable'
    },
    // 设置表格属性
    setTableAttr(id, rowCount, colCount) {
      // 根据当前id找到当前表格的index
      const tableIndex = this.svgLists.indexOf(this.svgLists.filter(f => f.id === id)[0])
      if (tableIndex === -1) {
        return
      }
      const svgType = this.svgLists.filter(f => f.id === id)[0].type
      if (svgType !== 'TableSvg') {
        return
      }
      const tableData = []
      for (let r = 0; r < rowCount; r++) {
        const tableColDataList = []
        for (let c = 0; c < colCount; c++) {
          if (this.svgLists[tableIndex].tableData.length >= r + 1 && this.svgLists[tableIndex].tableData[r].cols.length >= c + 1) {
            tableColDataList.push(this.svgLists[tableIndex].tableData[r].cols[c])
          } else {
            const tableColData = {
              'id': this.uuid(),
              'val': `${r + 1}行${c + 1}列`
            }
            tableColDataList.push(tableColData)
          }
        }
        const tableRowData = {
          'cols': tableColDataList
        }
        tableData.push(tableRowData)
      }
      this.svgLists[tableIndex].tableData = tableData
    },
    uuid(length = 16, chars) {
      let result = ''
      const charsString = chars || '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (let i = length; i > 0; --i) {
        result += charsString[Math.floor(Math.random() * charsString.length)]
      }
      return result
    }
  }
}
</script>
<style lang="scss">
.svg-editor-container{
  overflow: auto;
  height: 830px;
  display: flex;
  flex-direction: column;
  .editor-header{
    height: 110px;
    padding: 0 10px;
    //border-bottom: 1px solid #DCDFE6;
  }
  .svg-editor-body-container{
    height: calc(100% - 35px);
    display: flex;
    flex-direction: row;
    .attribute-panel-container{
      width: 260px;
    }
    .icon-panel-container{
      width: 200px;
      height: inherit;
      padding: 0 10px 10px 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .el-collapse{
        border-top: 0px;
      }
      .svg-nav-list {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        margin: 0;
        padding: 0;
        padding: 10px 0px;
        li {
          position: relative;
          width: calc(33.33% - 30px);
          margin: 0 15px 15px 15px;
          padding: 0;
          border-radius: 50%;
          box-shadow: 1px 1px 5px #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            box-shadow: 1px 1px 10px #ccc;
          }
          img {
            display: block;
            width: 100%;
          }
          .title {
            display: none;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }
        }
        &.two-item {
          li {
            width: calc(50% - 30px);
            height: 100px;
            margin-bottom: 25px;
            border-radius: 10px;

            img {
              width: auto;
              height: 100%;
            }
          }
        }
      }
    }
    .svg-editor-main-container{
      flex: 1;
      overflow: auto;
      position: relative;
      text-align: center;
      .canvansDiv{
        height: 100%;
        width: 100%;
      }
      .zoom-container{
        position: fixed;
        bottom: 5px;
        right: 280px;
      }
      #guide-x {
        display: none;
        position: absolute;
        width: 100%;
        left: 0px;
        top: 0px;
      }
      #guide-y {
        display: none;
        position: absolute;
        height: 100%;
        left: 0px;
        top: 0px;
      }
    }
    .attribute-panel-container{
      .jv-container .jv-code{
        padding: 0px;
      }
      .el-form-item__label{
        font-size: 12px;
      }
      .el-input.is-disabled .el-input__inner{
        background-color: #fff;
        border: 0;
        color: #606266;
      }
      .el-input-number--mini{
        width: 100%;
      }
    }
  }
}
</style>
